<script>
  export let headline;
</script>

<h1 class="page-headline">{headline}</h1>
